(function () {
  var SECTION_SELECTOR = '.oddit-section-featured-reviews';
  var TRACK_SELECTOR = '.oddit-section-featured-reviews__track';
  var CARD_SELECTOR = '.oddit-section-featured-reviews__card';
  var DOT_SELECTOR = '.oddit-section-featured-reviews__dot';
  var DOT_ACTIVE_CLASS = 'oddit-section-featured-reviews__dot--active';

  var sectionState = new Map();

  function initSection(section) {
    var track = section.querySelector(TRACK_SELECTOR);
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll(CARD_SELECTOR));
    var dots = Array.prototype.slice.call(section.querySelectorAll(DOT_SELECTOR));

    if (cards.length === 0 || dots.length === 0) return;

    /* ZAP-36: infinite loop.
       The carousel used to wrap with a modulo, so reaching the end rewound the
       whole track in one long visible scroll. Instead we append a duplicate of
       the card set: scrolling just keeps going forward, and once the viewport
       passes the end of the originals we subtract exactly one set-width from
       scrollLeft. The clones are pixel-identical to what is on screen at that
       moment, so the jump is invisible.

       originalCount stays the source of truth for dots and paging — everything
       downstream still reasons about the real slides only. */
    var originalCount = cards.length;
    var originals = cards.slice(0, originalCount);
    var loopEnabled = false;
    /* How many copies of the card set are on the track, originals included. */
    var setCount = 1;

    function appendCloneSet() {
      var frag = document.createDocumentFragment();
      for (var c = 0; c < originals.length; c++) {
        var clone = originals[c].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-clone', 'true');
        /* Keep clones out of the tab order — they are visual filler only. */
        var focusables = clone.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        for (var f = 0; f < focusables.length; f++) focusables[f].setAttribute('tabindex', '-1');
        frag.appendChild(clone);
      }
      track.appendChild(frag);
      cards = Array.prototype.slice.call(track.querySelectorAll(CARD_SELECTOR));
      setCount++;
    }

    if (originalCount > 1) {
      appendCloneSet();
      loopEnabled = true;
    }

    /* Distance from the first original to the first clone — i.e. exactly one
       full set including gaps.

       Cached. Reading offsetLeft forces a synchronous layout, and this is
       consulted from the scroll handler, which fires continuously through a
       momentum scroll — measuring every time janked the carousel. The value
       only changes when the track is re-laid-out, so onResize clears it. */
    var setWidthCache = null;
    var supportsScrollEnd = 'onscrollend' in window;

    /* Card images are lazy, clones included — cloneNode copies the attribute.
       That is right for the initial paint, but it means they only start
       fetching once nearly in view, so travelling along the track (and coming
       back round the loop) showed empty cards for a beat. Fetch the rest as
       soon as the carousel is going to move: on first interaction, or when
       autoplay starts. The clones share their originals' URLs, so they are
       cache hits. Runs once. */
    var warmed = false;

    function warmImages() {
      if (warmed) return;
      warmed = true;
      var lazy = track.querySelectorAll('img[loading="lazy"]');
      for (var i = 0; i < lazy.length; i++) lazy[i].loading = 'eager';
    }

    function getSetWidth() {
      if (!loopEnabled || !cards[originalCount] || !cards[0]) return 0;
      if (setWidthCache === null) {
        setWidthCache = cards[originalCount].offsetLeft - cards[0].offsetLeft;
      }
      return setWidthCache;
    }

    /* One clone set is not enough on its own.

       The rewind waits for the scroll to settle, so there has to be enough
       track past the rewind point to absorb a whole fling — with a single set
       the reader reaches the hard end mid-throw and the carousel simply stops
       dead instead of coming round. Budget three viewports of runway, and never
       fewer than three sets.

       ZAP-208: this used to run once, inline, at init. If the measurement came
       back 0 — which it does whenever the cards have not been laid out yet, e.g.
       fonts or avatars still loading — it fell back to the two-set minimum and
       was never revisited, because only setWidthCache is refreshed on resize,
       never the number of sets. Two sets is not enough to loop: the whole track
       is then 2 x setWidth, so the furthest scrollLeft can ever reach is
       (2 x setWidth) - clientWidth, and any rewind threshold at or above two
       sets is unreachable by construction. Nothing rewound, the track parked
       against its hard end, and the reader saw empty space past the last card.

       So it is a function now, it recomputes rather than trusting the first
       reading, and it is re-run once the page has finished loading and on every
       resize. It only ever adds sets, so repeat calls are cheap and idempotent. */
    function ensureRunway() {
      if (!loopEnabled) return;
      setWidthCache = null;
      var oneSet = getSetWidth();
      if (oneSet <= 0) return;
      var needed = Math.max(3, Math.ceil((3 * track.clientWidth) / oneSet) + 1);
      while (setCount < needed) appendCloneSet();
      setWidthCache = null;
    }

    ensureRunway();
    if (document.readyState === 'complete') {
      requestAnimationFrame(ensureRunway);
    } else {
      window.addEventListener('load', function () { requestAnimationFrame(ensureRunway); }, { once: true });
    }

    /* The onScroll guard below keeps scrollLeft inside [0, setWidth), which is
       what makes the forward loop safe — the clones only ever extend the track
       forwards. It also makes travelling BACKWARDS impossible: the jump that
       creates room to scroll back into lands above the threshold and is rewound
       before the motion can start, so the reader was pinned at the first review.

       Suspending the guard for the duration of that one gesture is the narrowest
       fix. It re-arms by itself as soon as the track has settled back inside the
       normal range, so a gesture that is abandoned midway cannot leave it off. */
    var loopGuardSuspended = false;

    /* Move the track forward by exactly one set so there is content to scroll
       back through. The frame it lands on is pixel-identical to the one it left,
       so nothing is visible except the backwards motion that follows. */
    function borrowSetForBackwards() {
      if (!loopEnabled) return 0;
      var setWidth = getSetWidth();
      if (setWidth <= 0) return 0;
      loopGuardSuspended = true;
      track.scrollLeft += setWidth;
      return setWidth;
    }

    function normaliseLoop() {
      if (!loopEnabled || loopGuardSuspended) return;
      var setWidth = getSetWidth();
      if (setWidth <= 0) return;

      /* The track is `scroll-snap-type: x mandatory`, so any assignment is
         re-snapped to the nearest snap point. That is fine here precisely
         because we move by exactly one set: every snap point in the clones maps
         onto the identical snap point in the originals, so the browser snaps to
         where we asked. Do NOT try to disable snapping around this — toggling
         it mid-scroll makes the engine re-snap to the old position instead. */
      if (track.scrollLeft >= setWidth) {
        track.scrollLeft = track.scrollLeft - setWidth;
      }
    }

    var autoplay = section.dataset.autoplay === 'true';
    var autoplaySpeed = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;

    var state = {
      scrollRaf: null,
      resizeRaf: null,
      autoplayTimer: null,
      abortController: typeof AbortController !== 'undefined' ? new AbortController() : null
    };
    sectionState.set(section.id || section, state);

    var signal = state.abortController ? { signal: state.abortController.signal } : undefined;

    function getScrollPadding() {
      return parseFloat(getComputedStyle(track).paddingLeft) || 0;
    }

    function getCurrentSlide() {
      var padding = getScrollPadding();
      var currentScroll = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;

      for (var i = 0; i < cards.length; i++) {
        var snapPos = cards[i].offsetLeft - padding;
        var dist = Math.abs(currentScroll - snapPos);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    /**
     * How many cards fit in the visible track, measured rather than assumed —
     * the count is driven by CSS and changes across breakpoints.
     */
    function getCardsPerPage() {
      if (cards.length < 2) return 1;

      var step = cards[1].offsetLeft - cards[0].offsetLeft;
      if (!step || step <= 0) step = cards[0].offsetWidth;
      if (!step || step <= 0) return 1;

      var styles = getComputedStyle(track);
      var inner =
        track.clientWidth -
        (parseFloat(styles.paddingLeft) || 0) -
        (parseFloat(styles.paddingRight) || 0);

      /* Round so a card peeking by a few pixels does not count as visible. */
      var fit = Math.round(inner / step);
      /* Clamp to the real slides — cards[] now includes the loop clones. */
      return Math.min(originalCount, Math.max(1, fit));
    }

    /**
     * Centre the run of whole cards in the band.
     *
     * The leading gutter was `max(80px, 50vw - 640px)`, which lined the first
     * card up with the 1280px content column — but the track bleeds to the
     * right viewport edge, so the column inset only ever applied on one side.
     * At 1728px that left 224px of empty band before the first card and cards
     * running off the right, which read as the row being pushed sideways.
     *
     * So the gutter is measured instead: fit as many whole cards as the band
     * holds, then split what is left over between the two edges. Whatever the
     * viewport, the space before the first card matches the space after the
     * last visible one.
     */
    function centreTrack() {
      if (!cards.length) return;

      var cardWidth = cards[0].offsetWidth;
      if (cardWidth <= 0) return;

      var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cardWidth;
      if (step <= 0) step = cardWidth;

      var gap = step - cardWidth;
      var available = track.clientWidth;

      /* +gap because the run needs one fewer gap than it has cards. */
      var fit = Math.max(1, Math.floor((available + gap) / step));
      var occupied = fit * step - gap;

      /* A single card wider than the band leaves this negative — the phone
         layout, where the card is deliberately 100vw minus its own gutters. */
      var gutter = Math.max(0, (available - occupied) / 2);

      section.style.setProperty(
        '--oddit-featured-reviews-track-gutter',
        Math.round(gutter) + 'px'
      );
    }

    /* Pages describe the real slides, never the clones — otherwise the dot row
       would double in length once looping is on. */
    function getPageCount() {
      return Math.max(1, Math.ceil(originalCount / getCardsPerPage()));
    }

    /**
     * One dot per page of visible cards, not per card. Liquid renders one dot
     * per card as the upper bound; the surplus is hidden here once we can
     * measure how many actually fit.
     */
    function syncDotCount() {
      var pages = getPageCount();
      for (var i = 0; i < dots.length; i++) {
        var used = i < pages;
        dots[i].hidden = !used;
        dots[i].style.display = used ? '' : 'none';
        dots[i].setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + pages);
      }
      /* A single page means there is nothing to page through. This hides the
         whole control row — the arrows live in it alongside the dots, and
         hiding only the dot list would have left two dead buttons behind. */
      var nav = section.querySelector('.oddit-section-featured-reviews__nav');
      if (nav) nav.hidden = pages < 2;
      return pages;
    }

    function getCurrentPage() {
      var perPage = getCardsPerPage();
      /* Fold clone indices back onto the originals so the dots keep tracking
         the real slide even while the viewport is over the duplicate set. */
      var slide = getCurrentSlide() % originalCount;
      var page = Math.floor(slide / perPage);
      return Math.min(getPageCount() - 1, Math.max(0, page));
    }

    function updateDots(activePage) {
      for (var i = 0; i < dots.length; i++) {
        if (i === activePage) {
          dots[i].classList.add(DOT_ACTIVE_CLASS);
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove(DOT_ACTIVE_CLASS);
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    function scrollToSlide(index) {
      if (!cards[index]) return;
      var padding = getScrollPadding();
      track.scrollTo({
        left: cards[index].offsetLeft - padding,
        behavior: 'smooth'
      });
    }

    function scrollToPage(pageIndex) {
      var perPage = getCardsPerPage();
      /* Clamp to the last card so the final page cannot overshoot the track. */
      var cardIndex = Math.min(cards.length - 1, pageIndex * perPage);
      scrollToSlide(cardIndex);
    }

    /* Rewinding mid-motion rewrites scrollLeft by a full set width while the
       browser is still animating, which makes the cards visibly slide across
       one another and kills the momentum. Deferred to a settle instead: once
       nothing is moving the frame we land on is pixel-identical to the one we
       left, so the jump cannot be seen. */
    var settleTimer = null;

    function onScrollEnd() {
      normaliseLoop();
    }

    function onScroll() {
      /* Hard guard, independent of scrollend. The settle-based rewind below is
         the normal path, but it is driven by a single event — when that does not
         fire (observed on a programmatic scroll, and reported as the carousel
         stopping at the end) nothing ever rewinds and the track parks against
         its hard end. Crossing two full sets means we are deep inside the
         clones, far from the visible cards, so correcting here is invisible. */
      if (loopGuardSuspended) {
        /* Back inside the normal range, so the gesture that borrowed a set is
           done with it. */
        var settled = getSetWidth();
        if (settled > 0 && track.scrollLeft < settled) loopGuardSuspended = false;
      } else if (loopEnabled) {
        var guardSet = getSetWidth();
        /* ZAP-208: the threshold was two sets, which is unreachable whenever the
           track only holds two — max scrollLeft is (2 x set) - clientWidth — so
           on those loads this never fired at all. One set is both always
           reachable and always safe to correct at: the clones are pixel
           identical to the originals, so subtracting exactly one set lands on
           the same rendering. */
        if (guardSet > 0 && track.scrollLeft >= guardSet) {
          track.scrollLeft -= guardSet;
        }
      }

      if (!supportsScrollEnd) {
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          settleTimer = null;
          normaliseLoop();
        }, 140);
      }

      /* Dots track the scroll live — cosmetic, so a frame of latency is fine. */
      if (state.scrollRaf) return;
      state.scrollRaf = requestAnimationFrame(function () {
        state.scrollRaf = null;
        updateDots(getCurrentPage());
      });
    }

    function onResize() {
      if (state.resizeRaf) return;
      state.resizeRaf = requestAnimationFrame(function () {
        state.resizeRaf = null;
        /* Card widths are viewport-derived, so the measured set width is stale
           after a resize. */
        setWidthCache = null;
        /* Before anything that reads the track's padding — the centred gutter
           is viewport-derived, and getCardsPerPage() subtracts it. */
        centreTrack();
        /* ZAP-208: a narrower set width means more sets are needed to keep the
           runway, and a resize is also the first chance to measure properly if
           the initial reading came back 0. */
        ensureRunway();
        syncDotCount();
        updateDots(getCurrentPage());
      });
    }

    /* Autoplay */
    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || getPageCount() <= 1) return;
      /* Autoplay moves the track on its own, so the images are needed whether
         or not the reader ever touches it. */
      warmImages();
      state.autoplayTimer = setInterval(function () {
        if (loopEnabled) {
          /* Always forward. The clone set means there is track ahead, and
             normaliseLoop() rewinds invisibly once we cross into it — so the
             long backwards rewind at the end of the set is gone. */
          var perPage = getCardsPerPage();
          scrollToSlide(getCurrentSlide() + perPage);
          return;
        }
        var next = (getCurrentPage() + 1) % getPageCount();
        scrollToPage(next);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (state.autoplayTimer) {
        clearInterval(state.autoplayTimer);
        state.autoplayTimer = null;
      }
    }

    ['pointerdown', 'wheel', 'touchstart'].forEach(function (type) {
      track.addEventListener(type, warmImages, Object.assign({ passive: true, once: true }, signal));
    });

    track.addEventListener('scroll', onScroll, Object.assign({ passive: true }, signal));
    if (supportsScrollEnd) {
      track.addEventListener('scrollend', onScrollEnd, Object.assign({ passive: true }, signal));
    }

    if (autoplay) {
      section.addEventListener('mouseenter', stopAutoplay, signal);
      section.addEventListener('mouseleave', startAutoplay, signal);
      section.addEventListener('touchstart', stopAutoplay, Object.assign({ passive: true }, signal));
      section.addEventListener('touchend', startAutoplay, signal);
    }

    for (var i = 0; i < dots.length; i++) {
      (function (index) {
        dots[index].addEventListener('click', function () {
          scrollToPage(index);
          if (autoplay) {
            stopAutoplay();
            startAutoplay();
          }
        }, signal);
      })(i);
    }

    /* Arrows step by a page — as many cards as currently fit, which is what
       autoplay advances by too, so a click and a tick move the same distance.

       Going back from the very start would hit the hard edge, since the clones
       only extend the track forwards. Jumping ahead by exactly one set first
       lands on a pixel-identical frame, so the scroll that follows reads as the
       row simply continuing backwards. */
    function page(direction) {
      warmImages();

      var perPage = getCardsPerPage();
      var current = getCurrentSlide();

      if (direction < 0 && current < perPage) {
        if (borrowSetForBackwards() > 0) {
          current = getCurrentSlide();
        } else {
          /* No loop to travel into, so wrap to the last page rather than
             stalling against the start. */
          scrollToPage(getPageCount() - 1);
          return;
        }
      }

      scrollToSlide(Math.max(0, Math.min(cards.length - 1, current + direction * perPage)));
    }

    var arrows = [
      [section.querySelector('.oddit-section-featured-reviews__arrow--prev'), -1],
      [section.querySelector('.oddit-section-featured-reviews__arrow--next'), 1]
    ];

    for (var a = 0; a < arrows.length; a++) {
      (function (button, direction) {
        if (!button) return;
        button.addEventListener('click', function () {
          page(direction);
          if (autoplay) {
            stopAutoplay();
            startAutoplay();
          }
        }, signal);
      })(arrows[a][0], arrows[a][1]);
    }

    /* Click-and-drag, mirroring the product carousel.

       Touch and trackpads already scroll this track natively; a mouse had only
       the dots and autoplay, so the reviews past the fold were effectively out
       of reach on a desktop. A movement threshold separates a drag from a
       click, so a card's link still opens on a plain click, and the click that
       follows a drag is swallowed.

       The track is moved by the delta since the last event rather than to an
       absolute offset from where the gesture began: the loop guard in onScroll
       rewinds scrollLeft by a whole set mid-gesture, and an absolute position
       computed from the pre-rewind baseline would snap the track straight back
       and cancel the loop. */
    var dragging = false;
    var didDrag = false;
    var dragStartX = 0;
    var dragLastX = 0;
    var DRAG_THRESHOLD = 5;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      didDrag = false;
      dragStartX = e.clientX;
      dragLastX = e.clientX;
    }, signal);

    track.addEventListener('pointermove', function (e) {
      /* Adopt an in-progress drag whose pointerdown was swallowed by a child.
         buttons === 1 means the primary button is still held. */
      if (!dragging && e.pointerType === 'mouse' && e.buttons === 1) {
        dragging = true;
        didDrag = false;
        dragStartX = e.clientX;
        dragLastX = e.clientX;
        return;
      }
      if (!dragging) return;

      if (!didDrag && Math.abs(e.clientX - dragStartX) < DRAG_THRESHOLD) return;

      if (!didDrag) {
        didDrag = true;
        track.classList.add('is-dragging');
        stopAutoplay();
        warmImages();
        if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
      }

      e.preventDefault();

      /* Dragging right scrolls back, and back past zero is the hard edge. Borrow
         a set the moment the gesture would cross it so the drag keeps running
         instead of sticking at the first review. */
      var delta = e.clientX - dragLastX;
      if (delta > 0 && track.scrollLeft - delta < 0) borrowSetForBackwards();

      track.scrollLeft -= delta;
      dragLastX = e.clientX;
    }, signal);

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      if (!didDrag) return;
      track.classList.remove('is-dragging');

      /* Releasing is the settle point: scrollend is not guaranteed after
         scrollLeft was driven by hand, and normaliseLoop is idempotent, so a
         later scrollend costs nothing. */
      normaliseLoop();
      if (autoplay) startAutoplay();

      /* When a drag ends off the track no click ever arrives, so didDrag would
         stay true and eat the reader's next real click. Clear it once the click
         belonging to this gesture has had its turn. */
      setTimeout(function () {
        didDrag = false;
      }, 0);

      if (track.releasePointerCapture && e.pointerId !== undefined) {
        try {
          track.releasePointerCapture(e.pointerId);
        } catch (err) {
          /* pointer already released */
        }
      }
    }

    track.addEventListener('pointerup', endDrag, signal);
    track.addEventListener('pointercancel', endDrag, signal);
    track.addEventListener('pointerleave', endDrag, signal);

    /* Swallow the click that follows a drag so it does not follow a card link. */
    track.addEventListener('click', function (e) {
      if (!didDrag) return;
      e.preventDefault();
      e.stopPropagation();
      didDrag = false;
    }, Object.assign({ capture: true }, signal));

    /* Native image drag would otherwise hijack the gesture. */
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    }, signal);

    window.addEventListener('resize', onResize, Object.assign({ passive: true }, signal));

    centreTrack();
    if (document.readyState !== 'complete') {
      /* A first measurement taken before the cards are laid out reads a zero
         card width and bails, leaving the CSS fallback gutter in place. */
      window.addEventListener('load', function () {
        requestAnimationFrame(centreTrack);
      }, { once: true });
    }

    syncDotCount();
    updateDots(getCurrentPage());
    startAutoplay();
  }

  function destroySection(section) {
    var key = section.id || section;
    var state = sectionState.get(key);
    if (!state) return;

    if (state.scrollRaf) {
      cancelAnimationFrame(state.scrollRaf);
      state.scrollRaf = null;
    }
    if (state.resizeRaf) {
      cancelAnimationFrame(state.resizeRaf);
      state.resizeRaf = null;
    }
    if (state.autoplayTimer) {
      clearInterval(state.autoplayTimer);
      state.autoplayTimer = null;
    }
    if (state.abortController) {
      state.abortController.abort();
    }
    sectionState.delete(key);
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();